<template>
  <v-dialog
    v-model="_active"
    @click:outside="_setActive(false)"
    class="d-flex justify-center"
    :width="cardWidth"
  >
    <v-card style="overflow-x: hidden; width:100%;" v-if="data">
      <v-card tile>
        <v-card-title
          color="primary"
          :style="`background-color:${$vuetify.theme.currentTheme.secondary}`"
        >
          <v-container>
            <v-row class="d-flex flex-row justify-space-between">
              <v-btn
                @click="activateEdit()"
                color="#2A6A91"
                class="mt-3"
                style="color:white;"
                id="current-rental-edit-button"
              >
                <v-icon xl>mdi-pencil</v-icon>
                {{ editText }}
              </v-btn>
              <div>
                <v-btn
                  @click="closeModal()"
                  color="#2A6A91"
                  class="mt-3"
                  style="color:white;"
                  id="current-rental-cancel-button"
                >
                  <v-icon xl>mdi-close</v-icon>
                  Cancel
                </v-btn>
                <v-btn
                  @click="updateScreen()"
                  v-if="edit"
                  color="#2A6A91"
                  class="ml-3 mt-3"
                  style="color:white;"
                  id="current-rental-save-edit-button"
                >
                  <v-icon xl>mdi-content-save</v-icon>
                  Save
                </v-btn>
              </div>
            </v-row>
          </v-container>
        </v-card-title>
        <div class="d-flex justify-center pt-10 pa-4">
          <h2 color="primary" :id="'current-rental-title-' + data.device_id">
            Screen - {{ data.device_id }}
          </h2>
        </div>
        <v-card>
          <form class="pa-3">
            <v-text-field
              v-model="session.uuid"
              label="Instance Id"
              id="current-rental-instance-id"
              filled
              required
              readonly
              :disabled="edit"
            ></v-text-field>
            <v-text-field
              v-model="session.device_id"
              label="RA #"
              id="current-rental-ra"
              filled
              readonly
              :disabled="edit"
            ></v-text-field>
            <v-select
              v-model="data.session_status"
              label="Checked In / Checked Out"
              color="primary"
              id="current-rental-session-status"
              filled
              dense
              :items="statusOptions"
              :readonly="!edit"
            ></v-select>
            <v-select
              v-model="data.status"
              label="Rental Status"
              color="primary"
              id="current-rental-status"
              filled
              dense
              :items="rentalStatusOptions"
              :readonly="!edit"
            ></v-select>
          </form>
        </v-card>
        <v-card>
          <form class="pa-3">
            <v-text-field
              v-model="dateCheckedOut"
              label="Date Checked Out"
              id="current-rental-checkout-date"
              filled
              append-icon="mdi-calendar"
              readonly
              :disabled="edit"
            ></v-text-field>
            <v-text-field
              v-model="timeCheckedOut"
              label="Time Checked Out"
              id="current-rental-checkout-time"
              filled
              append-icon="mdi-clock"
              readonly
              :disabled="edit"
            ></v-text-field>
            <v-text-field
              filled
              dense
              label="Expected Due Date"
              id="current-rental-due-date"
              color="primary"
              append-icon="mdi-calendar"
              v-model="session.expected_end_at"
              :readonly="!edit"
            ></v-text-field>
            <div class="d-flex justify-center" v-if="edit">
              <v-date-picker
                v-model="calendarDate"
                :min="expectedDueDateMin"
                no-title
                scrollable
                color="primary"
              >
              </v-date-picker>
            </div>
          </form>
        </v-card>
        <v-card>
          <form class="pa-3" v-if="data.destination">
            <v-select
              v-model="data.destination.name"
              label="Destination Store"
              filled
              id="current-rental-destination"
              :items="stores"
              required
              :readonly="!edit"
            ></v-select>
            <v-text-field
              v-model="data.destination.contact_name"
              label="Store Contact"
              id="current-rental-contact-name"
              filled
              readonly
              :disabled="edit"
            ></v-text-field>
            <v-text-field
              v-model="data.destination.contact_phone"
              label="Store Phone Number"
              id="current-rental-contact-phone"
              filled
              readonly
              :disabled="edit"
            ></v-text-field>
            <v-text-field
              filled
              dense
              label="Store SPM Email"
              id="current-rental-store-email"
              color="primary"
              v-model="data.destination.contact_emails"
              readonly
              :disabled="edit"
            ></v-text-field>
          </form>
          <v-card-title color="primary">Accessories Check In</v-card-title>
          <v-card>
            <v-card-title v-if="accessories.length < 1"
              >No Accessories Found</v-card-title
            >
            <data-card
              v-for="(accessory, i) in accessories"
              :key="i"
              v-else
              :noMargin="true"
            >
              <div class="font-weight-bold">
                {{ accessory.name }}
              </div>
              <div class="d-flex justify-space-between">
                <div class="d-flex">
                  <v-checkbox
                    class="ma-0 pa-0"
                    value="PRESENT"
                    dense
                    color="secondary"
                    @change="updateAccessory(accessory, 'PRESENT')"
                    :readonly="!edit"
                    v-model="accessory.status"
                  ></v-checkbox
                  ><span>Present</span>
                </div>
                <div class="d-flex">
                  <v-checkbox
                    class="ma-0 pa-0"
                    value="BROKEN"
                    dense
                    color="secondary"
                    :readonly="!edit"
                    @change="updateAccessory(accessory, 'BROKEN')"
                    v-model="accessory.status"
                  ></v-checkbox
                  ><span>Broken</span>
                </div>
                <div class="d-flex">
                  <v-checkbox
                    class="ma-0 pa-0"
                    dense
                    value="MISSING"
                    color="secondary"
                    :readonly="!edit"
                    @change="updateAccessory(accessory, 'MISSING')"
                    v-model="accessory.status"
                  ></v-checkbox
                  ><span>Missing</span>
                </div>
              </div>
            </data-card>
          </v-card>
        </v-card>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import { MobileView } from '@/mixins';
import DataCard from '@/components/app/DataCard.vue';

export default {
  components: {
    DataCard,
  },
  data: () => ({
    edit: false,
    statusOptions: ['checked in', 'checked out'],
    rentalStatusOptions: ['green', 'yellow', 'red'],
    data: null,
    dataCopy: null,
    stores: ['Avis Test'],
    calendarDate: null,
  }),
  mixins: [MobileView],
  props: ['data', 'session'],
  methods: {
    ...mapMutations({
      _setActive: 'screens/setEditScreen',
    }),
    ...mapActions({
      updateAccessories: 'screenDetails/updateAccessories',
      _uploadDetails: 'screenDetails/uploadDetails',
      updateSession: 'screenDetails/updateSession',
    }),
    updateScreen() {
      this.edit = false;
      const screenPayload = {
        uuid: this.data.uuid,
        session_status: this.data.session_status,
        status: this.data.status,
        // screenDestinationId: this.data.destination.id
      };
      const sessionObject = {
        uuid: this.session.uuid,
        expected_end_at: moment(this.session.expected_end_at).valueOf() / 1000,
      };
      this._uploadDetails(screenPayload);
      this.updateSession(sessionObject);
      this._setActive(false);
    },
    updateAccessory(accessory, status) {
      accessory.status = status;
      delete accessory.__typename;
      this.updateAccessories(accessory);
    },
    setData() {
      this.calendarDate = moment(this.session.expected_end_at).format(
        'YYYY-MM-DD',
      );
    },
    closeModal() {
      this.setData();
      if (this.edit) {
        this.edit = false;
        this.data = this.dataCopy;
      } else {
        this._setActive(false);
      }
    },
    activateEdit() {
      if (!this.edit) {
        this.dataCopy = JSON.parse(JSON.stringify(this.data));
        this.edit = true;
      }
    },
  },
  computed: {
    ...mapGetters({
      _active: 'screens/getEditScreen',
      accessories: 'screenDetails/getAccessories',
    }),
    editText() {
      if (this.edit) {
        return 'Editing';
      }
      return 'Edit';
    },
    expectedDueDateMin() {
      return moment(this.dateCheckedOut).format('YYYY-MM-DD');
    },
    timeCheckedOut() {
      return moment(this.session.start_at * 1000).format('hh:mm:ss a');
    },
    dateCheckedOut() {
      return moment(this.session.start_at * 1000).format('MM-DD-YYYY');
    },
    cardWidth() {
      if (this.showMobileView) {
        return '80%';
      }
      return '50%';
    },
  },
  watch: {
    _active: {
      handler() {
        if (this._active) {
          this.setData();
        }
      },
      deep: true,
    },
    calendarDate() {
      this.session.expected_end_at = moment(this.calendarDate).format(
        'MM-DD-YYYY',
      );
    },
  },
};
</script>

<style></style>
